import axios from '@/axios/config'

export default {
  namespaced: true,
  state: {
    zones: [],
  },
  mutations: {
    updateZones(state, payload) {
      state.zones = payload
    },
  },
  actions: {
    async getZones({ commit }, { include_counts = false } = {}) {
      const { data } = await axios.get('/api/zone', {
        params: { include_counts },
      })
      commit('updateZones', data)
      return data
    },
    async deleteZone({ dispatch }, { id }) {
      await axios.delete(`/api/zone/${id}`)
      dispatch('getZones', { include_counts: true })
    },
    async createZone({ dispatch }, data) {
      await axios.post('/api/zone', data)
      dispatch('getZones', { include_counts: true })
    },
    async updateZone({ dispatch }, { id, ...data }) {
      await axios.put(`/api/zone/${id}`, data)
      dispatch('getZones', { include_counts: true })
      dispatch('getListingsPicker', null, { root: true })
    },
  },
}
